// Shared handler for /api/adyen/paypal/update zero-amount early-return responses.
// Adyen rejects updateOrder when amount.value is 0; the backend returns 422 + reason.
//
// FET-2766: extracted so Jest can cover the payload shape without bootstrapping
// the classic checkout page. app.js assigns this object to
// window.PayPalUpdateOrderErrors for the same call sites the CMS page used.

export const REASON_ZERO_AMOUNT = 'zero_order_amount';

export const extractPayload = (source) => {
	if (!source) {
		return null;
	}
	if (source.data && typeof source.data === 'object') {
		return source.data;
	}
	if (source.error && source.error.data) {
		return source.error.data;
	}
	return null;
};

export const isZeroAmountResponse = (source) => {
	const payload = extractPayload(source);
	return payload?.reason === REASON_ZERO_AMOUNT;
};

export const getUserMessage = (source, fallback) => {
	if (isZeroAmountResponse(source)) {
		const payload = extractPayload(source);
		return payload?.message || 'Your cart total is $0.00. Please add an item to your cart before checking out with PayPal.';
	}
	return fallback || 'We could not update your PayPal order. Please try again.';
};

export const handle = (component, source, contextLabel) => {
	if (!isZeroAmountResponse(source)) {
		return false;
	}

	const message = getUserMessage(source);
	if (component && typeof component.clearAllErrors === 'function') {
		component.clearAllErrors();
	}
	if (component) {
		component.checkoutErrors = [message];
	}

	console.warn(`[Adyen|PayPal] Zero-amount updateOrder blocked (${contextLabel || 'unknown'})`);
	if (typeof window !== 'undefined' && window.CheckoutErrorMonitor) {
		window.CheckoutErrorMonitor.log(new Error(message), {
			operation: 'paypal_update_order_zero_amount',
			context: contextLabel,
		});
	}

	return true;
};

export const PayPalUpdateOrderErrors = {
	REASON_ZERO_AMOUNT,
	extractPayload,
	isZeroAmountResponse,
	getUserMessage,
	handle,
};

export default PayPalUpdateOrderErrors;
